import Vue from 'vue'
import router from '@/router'
import store from '@/store'

var biOSDevice = navigator.userAgent.match(/iPhone|iPad|iPod/i)

export function contextInitJSContext () {
  if (process.env.HYBRID) {
    if (!biOSDevice) {
      location.href = 'kpostsmarttv://contextInitJSContext'
    }
  }
}

export function contextRemoveIntroView () {
  if (process.env.HYBRID) {
    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextRemoveIntroView'
      })
    } else {
      window.Android.contextRemoveIntroView()
    }
  }
}

export function contextKakaoLogin () {
  if (process.env.HYBRID) {
    Vue.prototype.$showCustomLoading();

    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextKakaoLogin'
      })
    } else {
      window.Android.contextKakaoLogin()
    }
  }
  else {
    router.push({ name: 'sns', params: { info: {} } })
  }
}

export function contextNaverLogin () {
  if (process.env.HYBRID) {
    Vue.prototype.$showCustomLoading();

    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextNaverLogin'
      })
    } else {
      window.Android.contextNaverLogin()
    }
  }
  else {
    router.push({ name: 'sns', params: { info: {} } })
  }
}

export function contextFacebookLogin () {
  if (process.env.HYBRID) {
    Vue.prototype.$showCustomLoading();

    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextFacebookLogin'
      })
    } else {
      window.Android.contextFacebookLogin()
    }
  }
  else {
    router.push({ name: 'sns', params: { info: {} } })
  }
}

export function contextLogout () {
  if (process.env.HYBRID) {
    Vue.prototype.$showCustomLoading();

    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextLogout'
      })
    } else {
      window.Android.contextLogout()
    }
  }
  else {
    store.dispatch('setToken', '')
    store.dispatch('setId', '')
    store.dispatch('setName', '')
    store.dispatch('setUsername', '')

    router.push({ name: 'login', params: { info: {} } })
  }
}

export function contextSaveData (key, value) {
  if (process.env.HYBRID) {
    if (biOSDevice) {
      window.webkit.messageHandlers.testapp.postMessage({
        name: 'contextSaveData',
        params: {
          key: key,
          value: value
        }
      })
    } else {
      window.Android.contextSaveData(key, value)
    }
  }
  else {
    router.push({ name: 'sns', params: { info: {} } })
  }
}



// WEBPACK FOOTER //
// ./src/hybrid/index.js